import { CaretLeftOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Colors } from '../../helpers/Colors'
const GoClose = ({ path, mt = '10px', state = {} }) => {
    const history = useHistory()

    const onClick = () => history.push({ pathname: path, state: state })

    return (
        <Button onClick={onClick}style={{padding: '18px 40px 40px 40px', borderRadius: '10px', marginRight: '20px', alignContent: 'center'}}
        > Close</Button>
    )
}

export default GoClose